
import { Component, Prop, Mixins } from "vue-property-decorator"

// @ts-ignore
import PasswordInput from "@/components/Controls/PasswordInput.vue"
import { minLength, minValue, required, sameAs } from "vuelidate/lib/validators"
import { RuleDecl } from "vue/types/options"
import { validationMixin } from "vuelidate"

const validations = function (this: PasswordInput): RuleDecl {
	return {
		value: {
			required,
			minLength: minLength(this.minimumLength)
		},
		passwordConfirm: {
			required,
			matches: sameAs("value")
		},
		passwordScore: {
			secure: minValue(3)
		},
		passwordValid: {
			valid: (value: boolean) => value
		},
		password: ["value", "passwordValid", "passwordScore"]
	}
}

@Component({
	components: {
		"password-input": PasswordInput
	},
	validations: validations
})
export default class PasswordReset extends Mixins(validationMixin) {
	@Prop({ default: "" })
	value!: string

	@Prop({ default: 8 })
	minimumLength!: number

	@Prop({ default: false })
	disabled!: boolean

	@Prop({ default: null })
	error!: string | null

	public passwordScore: number = 0;
	public passwordValid: boolean = false;

	public passwordConfirm: string = "";

	passwordResetting: boolean = false;

	private get password () {
		return this.value
	}

	private set password (value: string) {
		this.$emit("input", value)
	}

	resetPassword () {
		this.$v.$touch()
		if (this.disabled || this.passwordResetting || this.$v.$invalid) {
			return
		}

		this.passwordResetting = true
		this.$emit("resetPassword", {
			newPassword: this.value,
			resetComplete: () => this.passwordResetting = false
		})
	}

	private updatePasswordScore (score: number) {
		this.passwordScore = score
	}

	private updatePasswordValid (valid: boolean) {
		this.passwordValid = valid
	}
}

